var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, } from "recharts";
import { colors } from "syf-component-library/defaultTheme";
import { getLanguageFromStorage } from "syf-js-utilities";
import buildLineChart from "./helpers";
import GraphWrapper from "./subcomponents";
var ScoreChart = function (_a) {
    var enrolledAccountDetails = _a.enrolledAccountDetails;
    var language = getLanguageFromStorage();
    return (_jsx(GraphWrapper, { children: _jsx(ResponsiveContainer, __assign({ width: "90%", height: "100%" }, { children: _jsxs(LineChart, __assign({ data: buildLineChart(enrolledAccountDetails, language) }, { children: [_jsx(CartesianGrid, {}), _jsx(XAxis, { dataKey: "month", padding: { left: 42, right: 42 } }), _jsx(YAxis, { dataKey: "score", padding: { top: 20, bottom: 20 }, domain: ["dataMin", "dataMax"] }), _jsx(Tooltip, {}), _jsx(Line, { dataKey: "score", stroke: colors.cyanBlue, strokeWidth: 4 })] })) })) }));
};
export default ScoreChart;
